import { ExternalLog } from "../externalLogging/ExternalLog";
import { UncaughtExceptionErrorLOFactory } from "../externalLogging/factories/UncaughtExceptionErrorLOFactory";
import { error } from "../logging/error";

//import LoaderInfo = createjs.LoaderInfo;
import ErrorEvent = createjs.ErrorEvent;
import { LoaderInfo } from "@goodgamestudios/createjs-utilities";
//import UncaughtErrorEvent = createjs.UncaughtErrorEvent;

export class UncaughtErrorEventHandler {
    private static _onlyLogUniqueErrors: boolean;
    private static errorLog: string[] = [];

    // TODO: @HTML5
    public static init(loaderInfo: LoaderInfo, onlyLogUniqueErrors: boolean = false): void {
        UncaughtErrorEventHandler._onlyLogUniqueErrors = onlyLogUniqueErrors;
        /*
         This check has been added because it's possible to have the InvokeEvent execute twice before
         the listener is removed. We don't want to have multiple log entries in splunk.
         */
        /*if (!loaderInfo.uncaughtErrorEvents.hasEventListener(UncaughtErrorEvent.UNCAUGHT_ERROR)) {
            loaderInfo.uncaughtErrorEvents.addEventListener(UncaughtErrorEvent.UNCAUGHT_ERROR, UncaughtErrorEventHandler.uncaughtErrorHandler);
        }*/

    }

    // TODO: @HTML5
    private static uncaughtErrorHandler(event: any): void {
        /*let message: string;

        if (event.error instanceof Error) {
            message = event.error.getStackTrace();

            /!*
             In a non-debugger version of the runtime (Flash Player 11.4 or earlier and AIR 1.4 or earlier)
             the Error.getStackTrace() method returns null
             *!/
            if (!message) {
                message = Error(event.error).message;
            }
        }
        else if (event.error instanceof ErrorEvent) {
            message = ErrorEvent(event.error).text;
        }
        else {
            message = event.error.toString();
        }

        if (UncaughtErrorEventHandler._onlyLogUniqueErrors) {
            let isUnique: boolean = true;
            for (let stack of UncaughtErrorEventHandler.errorLog) {
                if (message == stack) {
                    isUnique = false;
                    break;
                }
            }
            if (isUnique) {
                UncaughtErrorEventHandler.errorLog.push(message);
            }
            else {
                return;
            }
        }

        let stackLines: any[] = message.split("]");
        ExternalLog.logger.log(new UncaughtExceptionErrorLOFactory(UncaughtExceptionErrorLOFactory.UNDEFINED_ERROR, event, stackLines));
        error("UncaughtException: " + stackLines);*/
    }
}
